$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");

    var loop = $(this).attr('data-loop');
    $('.pp_var-autoship-discounts').addClass('hided');
    $('.pp_var-autoship-discounts[data="'+loop+'"]').removeClass('hided');
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }

    
  });

  $(".product-selector_atc").click(function () {
    $.getJSON("/cart.js", function (cart) {
      var existingIds = cart.items.map(function (item) {
        return item.id;
      });

      if ($(".product-selector_atc").attr("data-mode-champs") == "true") {
        var newUrl = $(".product-selector_outer.active_block")
          .find(".product-selector_block.active")
          .attr("data-champs-url");
        window.location.href = newUrl;
        return;
      }

      var items = [];
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var freqDropdown = $("#ps-freq-select");
        var currentSellingPlan = (freqDropdown.length && freqDropdown.val())
          ? freqDropdown.val()
          : $(".product-selector_outer.active_block")
              .find(".product-selector_block.active")
              .attr("data-selling-plan");

      if (mode == "sub") {
        items.push({ id: currentId, quantity: 1, selling_plan: currentSellingPlan });
      } else {
        items.push({ id: currentId, quantity: 1 });
      }
      console.log("currentId" + currentId);
      // $('.product-selector_block[data-id="' + currentId + '"]')
      //     .find(".real_variant-gift")
      //     .each(function () {
      //       var giftId = $(this).attr('data-id');
      //       console.log("giftId" + giftId);
      //       items.push({ id: giftId, quantity: 1 });
      //     });

      var giftIds = [];

      $('.product-selector_block[data-id="' + currentId + '"]')
        .find(".real_variant-gift")
        .each(function () {

          var giftId = $(this).attr('data-id');

          // Prevent duplicate gift add
          if (giftId && giftIds.indexOf(giftId) === -1) {
            giftIds.push(giftId);
            items.push({ id: giftId, quantity: 1 });
          }

        });

      var goToCheckout = $(".product-selector_atc").attr('data-checkout_go');

      if (goToCheckout == 'true'){
         $('#rebuy-cart').hide();
        if (items.length > 0) {
          // First: clear the cart
            $.ajax({
              type: "POST",
              url: "/cart/clear.js",
              dataType: "json",
              success: function () {

                // After clearing, add new items
                $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: { items: items },
                  dataType: "json",
                  success: function () {
                      window.location.href = '/checkout';
                    
                  },
                  error: function () {
                    alert("Error adding item to the cart.");
                  }
                });

              },
              error: function () {
                alert("Error clearing the cart.");
              }
            });

        }
      }
      else{
        if (items.length > 0) {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function () {
              
            },
            error: function () {
              alert("Error adding item to the cart.");
            },
          });
        }
      }
      
    });
  });


  // $(".product-selector_atc").click(function () {
  //   if ($(this).attr("data-mode-champs") == "true") {
  //     var newUrl = $(".product-selector_outer.active_block")
  //       .find(".product-selector_block.active")
  //       .attr("data-champs-url");

  //     window.location.href = newUrl;
  //   } else {

  //     var items = [];

  //     var currentId = $(".product-selector_outer.active_block")
  //       .find(".product-selector_block.active")
  //       .attr("data-id");
  //     var mode = $(".product-selector_outer.active_block").attr("data");
  //     var currentSellingPlan = $(".product-selector_outer.active_block")
  //       .find(".product-selector_block.active")
  //       .attr("data-selling-plan");
  //     if (mode == "sub") {

  //       data = {
  //         id: currentId,
  //         quantity: 1,
  //         selling_plan: currentSellingPlan,
  //       };

  //       items.push({ id: currentId, quantity: 1, selling_plan: currentSellingPlan });
  //     } else {

  //       data = {
  //         id: currentId,
  //         quantity: 1,
  //       };

  //       items.push({ id: currentId, quantity: 1 });
  //     }

  //     var giftMode = $('.product-selector_atc').attr('data-gifts');
  //     if (giftMode == 'true'){
  //       $('.product-selector_block[data-id="'+currentId+'"]').find('.variant_gift-data').each(function(){
  //         var currentGiftId = $(this).attr('data-id');
  //         var currentGiftQty = 1;

  //         items.push({ id: currentGiftId, quantity: currentGiftQty });
  //       });
  //     }
      

  //     jQuery.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       data: {
  //         items: items,
  //       },
  //       dataType: "json",
  //       success: function () {},
  //       error: function () {
  //         alert("Error adding item to the cart.");
  //       },
  //     });
  //   }
  // });
});
